import { createFileRoute } from '@tanstack/react-router';
import { fundingListSearchSchema } from '@/pages/ai-matching-results/lib/fundingListSearchSchema';
import { PrefecturalGrantsPage } from '@/pages/ai-matching-results/ui/PrefecturalGrantsPage';

export const Route = createFileRoute(
  '/_protected/projects/ai-matching-results/prefectural-grants/',
)({
  component: PrefecturalGrantsPage,
  validateSearch: (search) => fundingListSearchSchema.parse(search),
});
